import { Injectable } from '@angular/core';

@Injectable()
export class JsonSchemaService {


}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/services/json-schema.service.ts